<template>
    <div class="twoImageText">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <el-container>
                <el-row :gutter="20" style="width:100%">
                    <el-col :xs="24" :sm="12" v-for="(item,index) in twoImageTextList" :key="index">
                        <div class="coopCasesList">
                            <div class="coopCasesListImg">
                                <img :src="item.imgUrl" :alt="item.imgAlt">
                            </div>
                            <div class="text">
                                <p>{{item.title}}</p>
                                <span>{{item.summary}}</span>
                                <div style="padding:0 10px">
                                    <el-button size="text" plain @click="handleClick(i.linkUrl)" v-for="(i, index1) in item.data.buttons" :key="index1" >→ {{i.text}}</el-button>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-container>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    val: {}
  },
    data(){
        return{
            twoImageTextList:[]
        }
    },
    methods: {
        handleClick(row) {
            window.open(row, '_self');
        }
    },
    created() {
        this.twoImageTextList = this.val.attaches;
    },
    watch: {
      val(val) {
        this.twoImageTextList = this.val.attaches;
      }
    }

}
</script>
<style lang="less" scoped>
.twoImageText{
        .coopCasesList{
        width: 100%;
        overflow: hidden;
        margin-bottom: 10px!important;
        .coopCasesListImg{
            display: inline-block;
            overflow: hidden;
            border-radius: 4px;
            width: 230px;
            height: 230px;
            float: left;
            margin-bottom: 10px!important;
            img{
                height: 100%;
                display: block;
            }
        }
        .coopCasesListImg:hover{
            img{
                transform: scale(1.2);
                transition: all 3s;
            }
        }
        .text{
            flex: 1;
            font-size: 16px;
            line-height: 24px;
            text-align: left;
            padding-left:240px;
            padding-bottom:15px;
            vertical-align: middle;
            padding-top: 15px;
            p{
                font-size: 16px;
                color: #666;
                margin: 0;
                padding:5px 10px 5px;
                width: 100%;
                display:block;
                box-sizing: border-box;
                color: #d11a2e;
                font-weight: bold;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;  /*不换行*/
            }
            span{
                width: 100%;
                display: inline-block;
                font-size: 14px;
                padding:0 10px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp:4;
                text-overflow: ellipsis;
                min-height: 68px;
                overflow: hidden;
            }
            .el-button{
                color: #d11a2e;
                border:none;
                text-decoration: underline;
                margin-top:8px;
            }
            .el-button:hover{
                border:none;
                color: #d11a2e;
                text-decoration: none;
            }
            .el-button:focus{
                color: #d11a2e;
                border:none;
            }
        }

    }


}
</style>



// WEBPACK FOOTER //
// src/components/item/patch15.vue